// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 4277) return "static/chunks/4277-b4ebc3b2b18cc0d8.js";
	if (chunkId === 2077) return "static/chunks/2077-1a23bc1791133c80.js";
	if (chunkId === 3063) return "static/chunks/3063-71f38452a3cc8a72.js";
	if (chunkId === 7837) return "static/chunks/7837-1ab035fc267dfc7b.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 7753 ? "fc2f6fa8" : chunkId) + "." + {"3899":"37af19a0742c7d4a","6645":"879abb690f964b56","6937":"de12397cf66bf565","7753":"5fc16b590d1f7cbc","8742":"7607805d35041a2e","8865":"85ed58523ee71b40"}[chunkId] + ".js";
};